import { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import st from "./RadioBtn.module.scss";

interface IRadioBtnProps extends HTMLAttributes<HTMLInputElement> {
	/** Наименование контрола */
	name: string;
	/** Значение */
	value: string | number;
	/** Заголовок кнопки */
	label: string;
	/** Не доступно */
	disabled?: boolean;
	/** Выбранное состояние */
	checked?: boolean;

	multiple?: boolean;
};

/** Радио-кнопка */
const RadioBtn: FC<IRadioBtnProps> = ( { label, className, multiple, ...otherProps } ) => (
	<label className={classNames( st.wrapper, className )}>
		<input
			type={ multiple ? "checkbox" : "radio" }
			className={st.input}
			{...otherProps}
		/>
		<span className={st.label}>
			{label}
		</span>
	</label>
);

export default RadioBtn;
